module.exports = "<app-brand-icon\n  title=\"Seller Rewards\"\n  (logoClick)=\"goHome()\"\n></app-brand-icon>\n"